import { Edges, Outlines, useAnimations } from '@react-three/drei';
import { useGLTF } from '@react-three/drei';
import { useEffect, useState } from 'react';

export const Knight = () => {
  const [hovered, setHovered] = useState(false);
  const gltf = useGLTF('/models/characters/Knight.glb');
  const { actions } = useAnimations(gltf.animations, gltf.scene);

  useEffect(() => {
    gltf.scene.traverse((child: any) => {
      if (child.isMesh) {
        child.castShadow = true;
        // Store the original material color for each mesh
        child.userData.originalColor = child.material.color.clone();
      }
    });
  }, [gltf]);

  // Add this effect to handle the glow
  useEffect(() => {
    gltf.scene.traverse((child: any) => {
      if (child.isMesh) {
        if (hovered) {
          child.material.emissive.set('#678'); // Adjust color as needed
          child.material.emissiveIntensity = 1.5; // Adjust intensity as needed
        } else {
          child.material.emissive.set('#000000');
          child.material.emissiveIntensity = 0;
        }
      }
    });
  }, [hovered, gltf.scene]);

  useEffect(() => {
    actions['Sit_Floor_Idle']?.reset().fadeIn(0.5).play();
  }, [actions]);

  // Log the entire scene graph to see all meshes and their properties
  // console.log('Full model structure:', gltf.scene);

  // Log all materials
  // console.log('Materials:', gltf.materials);

  // Log all nodes/meshes
  // gltf.scene.traverse((node: any) => {
  //   console.log('Node name:', node.name);
  //   if (node.isMesh) {
  //     console.log('Mesh properties:', {
  //       name: node.name,
  //       material: node.material.name,
  //       morphTargets: node.morphTargetInfluences ? 'Yes' : 'No',
  //       visible: node.visible,
  //     });
  //   }
  // });

  console.log(hovered);
  return (
    <group>
      <primitive
        object={gltf.scene}
        position={[0, 0, 0]}
        scale={[0.334, 0.334, 0.334]}
        castShadow
        onPointerOver={() => {
          setHovered(true);
        }}
        onPointerOut={() => {
          setHovered(false);
        }}
      >
        {hovered && <Outlines thickness={10} color="#22bb33" screenspace={true} transparent opacity={1} />}
      </primitive>
    </group>
  );
};
